const magazineEnableTouchStartEvent = () => {
    window.ontouchstart = function () {};
    window.addEventListener('touchstart', () => {}, true);
    window.addEventListener('touchstart', () => {}, false);
}
export { magazineEnableTouchStartEvent };